export const backToStockValidationErrors = {
  'USER_INTERESTS_FORM.VALIDATION.EMAIL.INVALID': 'validationsErrors.invalidEmail',
}
